import moment from 'moment-timezone';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import ChatDetailModal from '../../../components/modal/ChatDetailModal';
import DetectorController, {
  ChatDetailType,
  ChatRoomType,
} from '../../../controller/DetectorController';

type ChatProps = {
  chat: ChatRoomType;
  isMobile: boolean;
  openChatDetail: (chat: ChatRoomType) => void;
};

const ChatItem = ({ chat, isMobile, openChatDetail }: ChatProps) => {
  const RenderOrderInfo = useMemo(() => {
    return (
      <div className="orderListWrap">
        <h4 className="name">
          {moment(chat.latest_chat_time).format('YYYY.MM.DD')} {chat.store_name}
        </h4>

        <div
          className="orderList"
          onClick={() => {
            if (isMobile) {
              openChatDetail(chat);
            }
          }}>
          <div className="row">
            <div className="room">
              <h3>{chat.area_name}</h3>
              {chat.unread_count > 0 && (
                <div className="roomCount">
                  <p>{chat.unread_count}</p>
                </div>
              )}
            </div>
            <h4>{chat.latest_chat}</h4>
          </div>
          <div className="row">
            <h5>{moment(chat.latest_chat_time).format('HH:mm')}</h5>
            <button className={`stateButton `} onClick={() => openChatDetail(chat)}>
              <div className="buttonComment">
                <h3>답변하기</h3>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }, [chat]);

  return (
    <>
      <Style>{RenderOrderInfo}</Style>
    </>
  );
};

export default ChatItem;

const Style = styled.div`
  .orderListWrap {
    padding: 28px 0;
    margin: 0 6%;
    border-bottom: 1px solid #e5e5e5;
  }
  .orderList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    .row {
      gap: 30px;
    }
  }

  h4 {
    display: -webkit-box;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
    color: #979797;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
  }

  h4.name {
    margin-bottom: 8px;
    color: #777;
  }

  h5 {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: #979797;
  }

  .room {
    position: relative;
    min-width: 90px;
    min-height: 90px;
    max-width: 90px;
    max-height: 90px;
    background: #f7f7f7;
    border: 1px solid #4dd2ae;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    h3 {
      font-weight: 500;
      color: #4dd2ae;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .roomCount {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ff6060;
      border-radius: 100px;
      p {
        font-size: 12px;
        line-height: 12px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .stateButton {
    position: relative;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 20px;
    outline: none;
    box-shadow: 2px 2px 2px 0px #00000040;
    background: #4dd2ae;
    border: none;
    cursor: pointer;
    h3 {
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      font-weight: 600;
      white-space: nowrap;
    }
  }

  @media (max-width: 900px) {
    .orderListWrap {
      padding: 16px 24px 16px 10px;
      margin: 10px;
      border: 1px solid #e5e5e5;
      border-radius: 10px;
    }
    .orderList {
      position: relative;
      gap: 0;
      cursor: pointer;
      .row {
        gap: 12px;
      }
    }

    h4 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      color: #555555;
    }
    h4.name {
      margin-bottom: 4px;
    }
    h5 {
      position: absolute;
      font-size: 12px;
      line-height: 14px;
      text-align: right;
      top: 10px;
      right: 24px;
    }

    .room {
      min-width: 72px;
      min-height: 72px;
      max-width: 72px;
      max-height: 72px;
      h3 {
        font-size: 18px;
      }
      .roomCount {
        position: absolute;
        width: 20px;
        height: 20px;
        p {
          font-size: 10px;
          line-height: 10px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }

    .stateButton {
      display: none;
    }
  }
`;
